import React from 'react';
import { Star } from '../icons';
import { colors } from '../utils/styles';
import styled from 'styled-components';

export const Rating = ({ total = 13, rate = 4, className }) => {
  return (
    <StyledRating className={className}>
      {[1, 2, 3, 4, 5].map(rating => (
        <Star key={rating} fill={rate >= rating ? colors.pink : '#F3B7CE'} />
      ))}
      <span>{total ? `(${total})` : ''}</span>
    </StyledRating>
  );
};

const StyledRating = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 0 0 10px;
  svg {
    margin-right: 5px;
  }
  > span {
    font-size: 10px;
    line-height: 15px;
    height: 15px;
  }
`;
